import { useContext } from 'react';
import { LocalizationContext } from './LocalizationContext';
export function useTranslate() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'textResolver' does not exist on type '{ ... Remove this comment to see the full error message
    var textResolver = useContext(LocalizationContext).textResolver;
    return textResolver;
}
